<template>
  <div>
    <el-form ref="formData" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_supplier_name_cn') || '供应商名称'"
            prop="scmName"
          >
            <el-input
              v-model="formData.scmName"
              maxlength="500"
              :placeholder="
                $l('form_label_supplierName_tips') || '请输入供应商名称'
              "
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_supplier_name_en') || '供应商英文名称'"
            prop="scmNameEn"
          >
            <el-input
              v-model="formData.scmNameEn"
              maxlength="500"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_province') || '省'"
            prop="provinceCode"
          >
            <el-select
              size="mini"
              v-model="formData.provinceCode"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              @change="loadCityOptions"
              filterable
              clearable
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_city') || '市'" prop="cityCode">
            <el-select
              size="mini"
              v-model="formData.cityCode"
              @change="loadDistrictOptions"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_area') || '区/县'"
            prop="districtCode"
          >
            <el-select
              size="mini"
              v-model="formData.districtCode"
              @change="changDistrictName"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="item in districtOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('form_label_supplier_businessLicense') || '统一社会征信代码'
            "
            prop="businessLicense"
          >
            <el-input
              v-model="formData.businessLicense"
              maxlength="500"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_address_detail') || '详细地址'"
            prop="scmAddress"
          >
            <el-input
              v-model="formData.scmAddress"
              maxlength="500"
              :placeholder="
                $l('form_label_addressDetail_tips') || '请填写详细地址'
              "
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('scm_info_scmAddressEn') || '详细地址(英文)'"
            prop="scmAddressEn"
          >
            <el-input
              v-model="formData.scmAddressEn"
              maxlength="500"
              :placeholder="
                $l('tips_input_scm_info_scmAddressEn') || '请填写详细地址(英文)'
              "
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <BankTable
          ref="bankTable"
          :disabled="disabled"
          :scmInfoBankList="formData.scmInfoBankList"
        />
      </el-row>

      <el-row class="d2-mt">
        <el-col :span="16">
          <el-form-item
            :label="$l('form_label_whyy') || '维护原因'"
            label-width="80px"
            prop="whyy"
          >
            <el-input
              v-model="formData.whyy"
              maxlength="50"
              :placeholder="$l('tips_input_scm_info_whyy') || '请填写维护原因'"
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div class="d-flex justify-content-end" v-if="!disabled">
            <el-button @click="save" type="primary" size="small">
              {{ $l('form_submit_application') || '提交申请' }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import BankTable from '../bank-table/table'

export default {
  mixins: [EditLoading],
  components: { BankTable },
  props: {
    scmCode: String,
    pageType: String,
    diversity: String,
  },
  data() {
    return {
      disabled: false,
      cityValid: false,
      districtValid: false,
      bankAccountKindParams: { dictType: 'bankAccountKind' },
      formData: {
        districtCode: '',
      },
      provinceOptions: [], //  省份
      cityOptions: [], //  市
      districtOptions: [], //  县
      rules: {
        scmName: [
          {
            required: true,
            message:
              this.$l('form_label_supplierName_tips') || '请输入供应商名称',
            trigger: 'blur',
          },
        ],
        whyy: [
          {
            required: true,
            message: this.$l('tips_label_whyy') || '请输入维护原因',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    if (this.scmCode !== '') {
      this.init()
    }
  },
  methods: {
    async init() {
      this.reset()
      await this.loadDetail()
      this.loadProvinceOptions()
    },
    async loadDetail() {
      if (!this.scmCode) return
      return this.$api
        .scmInfoDetailApi({ scmCode: this.scmCode })
        .then((res) => {
          const data = res.body
          this.formData = {
            scmCode: data.scmCode,
            scmName: data.scmName,
            scmNameEn: data.scmNameEn,
            provinceCode: data.provinceCode,
            provinceName: data.provinceName,
            cityCode: data.cityCode,
            cityName: data.cityName,
            districtCode: data.districtCode,
            districtName: data.districtName,
            scmAddress: data.scmAddress,
            scmAddressEn: data.scmAddressEn,
            businessLicense: data.businessLicense,
            bankName: data.bankName,
            bankAccountName: data.bankAccountName,
            bankAccountNo: data.bankAccountNo,
            bankAccountType: data.bankAccountType,
            bankAccountKind: data.bankAccountKind,
            scmInfoBankList: data.scmInfoBankList,
          }
          // }
        })
    },
    // 省份下拉
    loadProvinceOptions() {
      let regionDictParam = { levelType: '1', parentId: '0' }
      // 省份下拉
      this.$api
        .baseRegion(regionDictParam)
        .then((res) => {
          this.provinceOptions = res.body.data
          this.loadCityOptions(this.formData.provinceCode)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 市级下拉
    loadCityOptions(value) {
      const data = this.provinceOptions.find((item) => {
        return item.value === value
      })
      this.formData.provinceName = data ? data.label : ''
      let regionDictParam = {
        levelType: '2',
        parentId: this.formData.provinceCode,
      }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.cityOptions = res.body.data
          // 当省级发生变化时,清空市县
          if (this.cityValid) {
            this.formData.cityCode = ''
            this.formData.cityName = ''
            this.formData.districtCode = ''
            this.formData.districtName = ''
          }
          this.loadDistrictOptions(this.formData.cityCode)
          this.cityValid = true
        })
      } else {
        this.formData.cityCode = ''
        this.formData.cityName = ''
        this.formData.districtCode = ''
        this.formData.districtName = ''
        this.cityOptions = []
        this.districtOptions = []
      }
    },
    // 县级下拉
    loadDistrictOptions(value) {
      const data = this.cityOptions.find((item) => {
        return item.value === value
      })
      this.formData.cityName = data ? data.label : ''
      let regionDictParam = {
        levelType: '3',
        parentId: this.formData.cityCode,
      }
      if (
        regionDictParam.parentId !== null &&
        regionDictParam.parentId !== ''
      ) {
        this.$api.baseRegion(regionDictParam).then((res) => {
          this.districtOptions = res.body.data
          // 当市级发生变化时,清空区县
          if (this.districtValid) {
            this.formData.districtCode = ''
            this.formData.districtName = ''
          }
          this.districtValid = true
        })
      } else {
        this.formData.districtCode = ''
        this.formData.districtName = ''
        this.districtOptions = []
      }
    },
    changDistrictName(value) {
      const data = this.districtOptions.find((item) => {
        return item.value === value
      })
      this.formData.districtName = data ? data.label : ''
    },

    //供应商信息变更
    save() {
      var scmInfoBankList = this.$refs.bankTable.getTableData()

      if (!scmInfoBankList || scmInfoBankList.length == 0) {
        this.$message.warning('请添加银行账号信息')
        return
      }
      this.formData.scmInfoBankList = scmInfoBankList
      console.log('this.formData', this.formData)

      validate.formValidate([this.$refs.formData], (valid) => {
        if (valid) {
          this.loadingOpen()
          this.$api
            .scmInfoApplyApi(this.formData)
            .then((res) => {
              this.$api
                .scmInfoOaApplyApi({
                  scmCode: res.body,
                  linkUrl: this.$joinURL(`/opview/scm/${this.formData.scmCode}`, {
                    joinOrigin: true,
                    joinBasePath: false,
                  }),
                })
                .then(() => {
                  this.$message.success(
                    this.$l('INDEX.tips_Submitted_successfully') || '提交成功!'
                  )
                  this.close()
                })
                .catch(() => {
                  this.scmInfoRollbackApply(res.body)
                  this.close()
                })
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    },
    scmInfoRollbackApply(scmCode) {
      this.$api.scmInfoRollbackApplyApi({ scmCode: scmCode }).then(() => {})
    },
    reset() {
      this.cityValid = false
      this.districtValid = false
      this.formData = {
        scmCode: '',
        scmName: '',
        scmNameEn: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        scmAddress: '',
        businessLicense: '',
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        bankAccountType: '',
        bankAccountKind: '',
      }
    },
    close() {
      this.loadingClose()
      this.$emit('close')
    },
  },
}
</script>
